import React from 'react';
import Icon from '../../icon';

class YearPanelHeader extends React.PureComponent {
  getDecadeLabel = date => {
    const year = date.year();
    const start = parseInt(year / 12, 10) * 12;
    const end = start + 11;
    return `${start}-${end}`;
  };

  render() {
    const { prefix, visibleMonth, locale, goPrevDecade, goNextDecade, modes, changeMode } = this.props;
    const decadeLabel = this.getDecadeLabel(visibleMonth);
    const btnCls = `${prefix}calendar-btn`;

    return (
      <div className={`${prefix}calendar-panel-header`}>
        <button
          role="button"
          title={locale.prevDecade}
          className={`${btnCls} ${btnCls}-prev-decade`}
          onClick={goPrevDecade}
        >
          <Icon type="chevrons-left" />
        </button>
        <div
          className={`${prefix}calendar-panel-header-full`}
          title={decadeLabel}
          onClick={() => { modes.includes('date') && changeMode('date'); modes.includes('month') && changeMode('month');}}
        >
          {decadeLabel}
        </div>
        <button
          role="button"
          title={locale.nextDecade}
          className={`${btnCls} ${btnCls}-next-decade`}
          onClick={goNextDecade}
        >
          <Icon type="chevrons-right" />
        </button>
      </div>
    );
  }
}

export default YearPanelHeader;
